import { useState, useEffect } from 'react';
import { Api, findActiveSubscription } from '../lib';

export default function useSubscriptionStatus(isLoggedIn, teamId) {
  const [isSubscribed, setIsSubscribed] = useState(false);

  useEffect(() => {
    if (!isLoggedIn || !teamId) return;

    let cancelled = false;

    async function check() {
      const res = await Api.get('/subscriptionPlans/status');
      if (cancelled) return;
      if (res?.data) {
        const subscriptions = Array.isArray(res.data) ? res.data : [res.data];
        const found = findActiveSubscription(subscriptions, teamId);
        setIsSubscribed(!!found);
      }
    }

    check();
    return () => { cancelled = true; };
  }, [isLoggedIn, teamId]);

  return isSubscribed;
}
